import { useEffect, useLayoutEffect } from 'react'

// On the server useLayoutEffect is a no-op and triggers a React warning.
// This re-export silences it by falling back to useEffect during SSR while
// preserving synchronous DOM-measurement semantics in the browser.
const useIsomorphicLayoutEffect =
  typeof window !== 'undefined' ? useLayoutEffect : useEffect

export default useIsomorphicLayoutEffect
